import { Icon } from "semantic-ui-react";

import { PIN_TYPES } from "models";

import type { TFunction } from "i18next";

type IconAndMessageProps = {
  t: TFunction;
  pinType: PIN_TYPES;
};

const PinTypeIconMessageConfig = new Map<PIN_TYPES, { icon: string; translationKey: string; defaultText: string }>([
  [PIN_TYPES.Recall, { icon: "registered", translationKey: "v8_recalls", defaultText: "Recalls" }],
  [PIN_TYPES.Remarks, { icon: "thumb tack", translationKey: "v8_remarks", defaultText: "Remarks" }],
  [PIN_TYPES.Warranty, { icon: "shield halved", translationKey: "v8_warranty", defaultText: "Warranty" }]
]);

export const PinTypeIconAndMessage = ({ t, pinType }: IconAndMessageProps) => {
  const pinConfig = PinTypeIconMessageConfig.get(pinType);
  if (!pinConfig) return null;

  return (
    <div className="pin-type-container">
      <div>
        <Icon className={`green-lime ${pinConfig.icon}`} />
      </div>
      <span>{t(pinConfig.translationKey, pinConfig.defaultText)}</span>
    </div>
  );
};
